import { render, staticRenderFns } from "./AudioCardContent.vue?vue&type=template&id=63601773&"
import script from "./AudioCardContent.vue?vue&type=script&lang=ts&"
export * from "./AudioCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports